<template>
  <gh-table-page ref="table" :args-query="args" module="dynamic_cls" :cls="cls" sort-by="Seq">
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="args.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @change="$refs.table.query()">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import TablePage from "./tablePage.ts";
  export default TablePage;
</script>